import { Link } from "@tanstack/react-router";
import { TeaserImage } from "./TeaserImage";
import { Button } from "./ui/button";
import { cn } from "~/lib/utils";
import { ChevronRight } from "lucide-react";
import { RichTextRenderer } from "~/components/RichTextRenderer";

export const TeaserHorizontalWide = ({
  eyebrow,
  title,
  description,
  image,
  link,
  ctaLabel,
  ctaLabelColor,
  secondaryLink,
  secondaryCtaLabel,
  inverted,
}: {
  eyebrow: string;
  title: string;
  description: string;
  image: string;
  link: string;
  ctaLabel: string;
  ctaLabelColor?: string;
  secondaryLink?: string;
  secondaryCtaLabel?: string;
  inverted?: boolean;
}) => {
  return (
    <div className="layout-place-full-width grid lg:grid-cols-2">
      <TeaserImage
        image={image}
        alt=""
        square={true}
        className={inverted ? "order-2" : ""}
      />
      <div className={cn("p-10 md:p-20", inverted ? "order-1" : "")}>
        <p className="text-base font-semibold">{eyebrow}</p>
        <h2 className="mt-6 text-5xl font-medium">{title}</h2>
        <RichTextRenderer
          additionalClasses="text-lg mt-6"
          richText={description}
        />
        <div className="flex gap-4">
          <Button
            variant={ctaLabelColor === "black" ? "black" : "default"}
            asChild
            size={"lg"}
          >
            <Link to={link} className="mt-6 flex items-center gap-1">
              {ctaLabel}
            </Link>
          </Button>
          {secondaryLink && secondaryCtaLabel && (
            <Button variant={"ghost"} asChild size={"lg"}>
              <Link to={secondaryLink} className="mt-6 flex items-center gap-1">
                {secondaryCtaLabel}
                <ChevronRight />
              </Link>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
